import { CoreParameterModel } from '@fi-shared/models';

export class Statistic2ReportParameterModel extends CoreParameterModel {
    constructor(showOnDashboardFilter?: boolean) {
        super();
        this.Offset = undefined;
        this.NumberOfRecordsToTake = undefined;
        this.SelectedSort = {
            ColumnName: 'SortIndex',
            SortDirection: false,
        };
        this.ShowOnDashboardFilter = showOnDashboardFilter;
    }

    ShowOnDashboardFilter: boolean;
}
